document.addEventListener('DOMContentLoaded', () => {
    const tabGroups = document.querySelectorAll('.solution-tabs');

    if (!tabGroups.length) return;

    tabGroups.forEach(group => {
        const tabItems = group.querySelectorAll('.tab-item');
        const tabPanels = group.querySelectorAll('.tab-panel');

        tabItems.forEach(item => {
            item.addEventListener('click', () => {
                const targetId = item.getAttribute('data-tab');

                // Deactivate all tabs and panels WITHIN THIS GROUP
                tabItems.forEach(t => t.classList.remove('active'));
                tabPanels.forEach(p => p.classList.remove('active'));

                // Activate clicked tab and target panel
                item.classList.add('active');
                const targetPanel = document.getElementById(targetId);
                if (targetPanel) {
                    targetPanel.classList.add('active');
                    
                    // UX FIX: Scroll back to the top of THIS SPECIFIC section so user sees the content
                    const section = item.closest('.gn-solution');
                    if (section) {
                        section.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }
                }
            });
        });
    });
});
